export class PageManager {
    static oneTimeClasses = [];
    static oneTimeFunctions = [];
    static commonClasses = [];
    static disposableClasses = [];
    static pageSpecificClasses = {};
    static activeInstances = new Map();
    static currentContainer = null;

    static initApplication() {
        this.oneTimeClasses.forEach(ClassRef => {
            if (!this.activeInstances.has(ClassRef)) {
                const instance = new ClassRef(document);
                this.activeInstances.set(ClassRef, instance);
            }
        });

        this.oneTimeFunctions.forEach(FunctionRef => {
            FunctionRef();
        });
    }

    static initCommonClasses() {
        if (!this.currentContainer) return;

        this.commonClasses.forEach(ClassRef => {
            if (!this.activeInstances.has(ClassRef)) {
                const instance = new ClassRef(this.currentContainer);
                this.activeInstances.set(ClassRef, instance);
            }
        });
    }

    static startCommonClasses() {
        this.commonClasses.forEach(ClassRef => {
            const instance = this.activeInstances.get(ClassRef);
            if (instance && typeof instance.start === 'function') {
                instance.start();
            }
        });
    }

    static initPageClasses(namespace) {
        if (!this.currentContainer) return;

        const pageClasses = this.pageSpecificClasses[namespace]?.enter || [];
        pageClasses.forEach(ClassRef => {
            if (!this.activeInstances.has(ClassRef)) {
                const instance = new ClassRef(this.currentContainer);
                this.activeInstances.set(ClassRef, instance);
            }
        });
    }

    static disposeClasses() {
        // Dispose common disposable classes
        this.disposableClasses.forEach(ClassRef => {
            const instance = this.activeInstances.get(ClassRef);
            if (instance && typeof instance.dispose === 'function') {
                instance.dispose();
            }
            this.activeInstances.delete(ClassRef);
        });
    }

    static disposePageClasses(namespace) {
        const pageClasses = this.pageSpecificClasses[namespace]?.leave || [];
        pageClasses.forEach(ClassRef => {
            const instance = this.activeInstances.get(ClassRef);
            if (instance && typeof instance.dispose === 'function') {
                instance.dispose();
            }
            this.activeInstances.delete(ClassRef);
        });
    }
}
